import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContactMessageService {

  constructor(private http: HttpClient) { }

  createContactMessage(contactMessage: any) {
    return this.http.post(`https://api-prod.kharaaj.com/api/v1/contact-messages`, contactMessage);
  }
}
